module.exports = __webpack_public_path__ + "img/1-11.59dd38ca.png";